module.exports = __webpack_public_path__ + "static/holdphone-2-63d3447e66b17302733cef0dc7605bd5.png";